import { render } from "./DeleteRequestModal.vue?vue&type=template&id=d78fbc36&scoped=true"
import script from "./DeleteRequestModal.vue?vue&type=script&lang=js"
export * from "./DeleteRequestModal.vue?vue&type=script&lang=js"

import "./DeleteRequestModal.vue?vue&type=style&index=0&id=d78fbc36&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d78fbc36"]])

export default __exports__